import { Logo } from "@/Icons/Logo";
import { CrossIcon } from "@/Icons/cross";
import { useConfig } from "@/api/hooks/useConfig";
import { NavHeaderTypeEnum } from "@/components/Sidebar/Sidebar.interface";
import { NavSection } from "@/components/Sidebar/components/NavSection";
import { useTrans } from "@/translations";

import React from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

interface SidebarProps {
  showSidebar: boolean;
  toggleMenu: () => void;
}

export const SidebarMWM: React.FC<SidebarProps> = ({
  showSidebar,
  toggleMenu,
}) => {
  const { t } = useTrans();
  const { config } = useConfig();

  if (!config) return null;

  const faqKey = config.useExternalCRM ? "hints:faq_BIR" : "hints:faq";

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-10 flex w-64 ${
        !showSidebar && "-translate-x-full"
      } bg-lime transform flex-col transition duration-200 ease-in-out md:translate-x-0`}
    >
      <div className="bg bg-buttery-lime z-20 flex h-16 w-full items-center px-5">
        <Link to="/">
          <div className="flex h-16 items-center">
            <Logo />
          </div>
        </Link>
        <button
          onClick={toggleMenu}
          className="visible absolute right-4 md:hidden"
        >
          <CrossIcon className="h-4 w-4" />
        </button>
      </div>
      <nav className="overflow-auto py-8">
        <ul>
          <NavSection type={NavHeaderTypeEnum.General} />
          <NavSection type={NavHeaderTypeEnum.Customers} />
          <NavSection type={NavHeaderTypeEnum.Infrastructure} />
        </ul>
      </nav>
      <div className="mt-auto">
        <NavLink
          to={t(faqKey)}
          className="hover:bg-buttery-lime flex h-10 items-center justify-center underline transition-colors"
          target="_blank"
        >
          {t("sidebarLabels:faq")}
        </NavLink>
        <p className="mt-2 text-center text-xs">
          Carrot Insight v{import.meta.env.VITE_VERSION}
        </p>
        <p className="mt-2 pb-12 text-center text-xs">
          <a href="mailto:support@carrot.tech" className="underline">
            support@carrot.tech
          </a>
        </p>
      </div>
    </aside>
  );
};

export default SidebarMWM;
